import { render, staticRenderFns } from "./EditarProcedimentoOrigemContratoCentralizado.vue?vue&type=template&id=4821594e&scoped=true"
import script from "./EditarProcedimentoOrigemContratoCentralizado.vue?vue&type=script&lang=ts"
export * from "./EditarProcedimentoOrigemContratoCentralizado.vue?vue&type=script&lang=ts"
import style0 from "./EditarProcedimentoOrigemContratoCentralizado.vue?vue&type=style&index=0&id=4821594e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4821594e",
  null
  
)

export default component.exports